export default __webpack_public_path__ + "static/backend-as-a-service-0-32ff3a808d72b35f53a2a75998324836.png";